import type { IStringTool } from "../core/IStringTool.ts"

interface LerpInput {
  /** Starting value of the interpolation. */
  from: number

  /** Target value to interpolate towards. */
  to: number

  /** Interpolation progress between 0 (start) and 1 (end). */
  progress: number
}

export default class LerpTool implements IStringTool<LerpInput, number> {
  /**
   * Calculates the linear interpolation between two values.
   * @returns Interpolated value.
   */
  process({ from, to, progress }: LerpInput): number {
    return (to - from) * progress
  }
}

